import {
  createStyles,
  Title,
  Text,
  Button,
  Container,
  Group,
  useMantineTheme
} from '@mantine/core';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: 80,
    paddingBottom: 120,
    fontFamily: 'Inter'
    // backgroundColor: theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background,
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    fontFamily: 'Inter',
    marginBottom: theme.spacing.xl * 1.5,
    color:
      theme.colorScheme === 'dark'
        ? theme.colors.dark[4]
        : theme.colors.gray[2],

    [theme.fn.smallerThan('sm')]: {
      fontSize: 120
    }
  },

  title: {
    fontFamily: 'Inter',
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,
    color: theme.black,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 32
    }
  },

  description: {
    maxWidth: 540,
    margin: 'auto',
    fontFamily: 'Inter',
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.xl * 1.5,
    color: theme.black
  }
}));

export function ServerError() {
  const { classes } = useStyles();
  const theme = useMantineTheme();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>500</div>
        <Title className={classes.title}>Something bad just happened...</Title>
        <Text
          size="lg"
          align="center"
          className={classes.description}
        >
          Our servers could not handle your request. Don&apos;t worry, our
          development team was already notified. Try refreshing the page.
        </Text>
        <Group position="center">
          <Button
            size="md"
            className="font-normal"
            style={{ fontFamily: 'Inter' }}
            sx={{
              backgroundColor: theme.colors.primaryColors[0],
              fontWeight: 400
            }}
            color={theme.colors.lightColors[0]}
            onClick={() => window.location.reload()}
          >
            Refresh the page
          </Button>
        </Group>
      </Container>
    </div>
  );
}
